import axios from '../common/js/axios'


// 考试课程
const EXAM_COURSE = '/app/userExam/myCourseInfo'
// 学习记录
const EXAM_LIST = "/app/userExam/examList"
// 查看分析报告
const RECORD_INFO = '/app/userExam/getRecordInfo'
// 每日一练
const DAY_EXAM = '/app/userExam/beginDayExam'
// 提交答案
const SUBMIT_QUESTION = '/app/userExam/submitQuestion'
// 收藏试题
const ADD_FAV = '/app/userExam/addFav'
// 取消收藏
const DEL_FAV = '/app/userExam/deleteFav'
// 课程的章节练习列表数据接口
const KPOINT_EXAM = '/app/userExam/kpointExamList'
// 章节 开始做题
const  START_EXAM_CHAPTER = '/app/userExam/beginKpointExam'
// 模拟考试列表
const MOCK_EXAM_LIST = '/app/userExam/paperList'
// 开始模拟考试
const START_MOCK_EXAM = '/app/userExam/beginPaperExam'
// 交卷
const SUBMIT_EXAM = '/app/userExam/submitExam'
// 我的收藏
const FAV_LIST = '/app/userExam/favList'
// 错题集
const ERROR_LIST = '/app/userExam/errorList'
// 查看课程练习报告接口
const USER_EXAM_INFO = '/app/userExam/queryUserExamTotalInfo'
// 删除错题 
const DELETE_ERROR = '/app/userExam/deleteError'
//微官网考试列表 
const WXWEBSITE_PAPERLIST= '/app/wxWebsite/paperList'
//微官网考试
const WXWEBSITE_PAPERDETAIL = '/app/wxWebsite/paperDetail'
//微官网用户考试记录
const WXWEBSITE_USEREXAMRECORD = '/app/wxWebsite/userExamRecord'
//微官网用户考试记录
const WXWEBSITE_EXAMDICTLIST = '/app/wxWebsite/examDictList'

const EXANQUERYPAPERINFO = `/app/userExam/queryPaperInfo`
export function getExamList(data) {
	return axios({
		url: EXAM_LIST,
        params: data,
        method: "GET"
	})
}

export function getExamCourse(data) {
	return axios({
		url: EXAM_COURSE,
        params: data,
        method: "GET"
	})
}

export function getRecordInfo(data) {
	return axios({
		url: RECORD_INFO,
        params: data,
        method: "GET"
	})
}

export function getDayExam(data) {
	return axios({
		url: DAY_EXAM,
        params: data,
        method: "GET"
	})
}

export function getSubmitQuestion(data) {
	return axios({
		url: SUBMIT_QUESTION,
        params: data,
        method: "GET"
	})
}

export function getAddFav(data) {
	return axios({
		url: ADD_FAV,
        params: data,
        method: "GET"
	})
}

export function getDelFav(data) {
	return axios({
		url: DEL_FAV,
        params: data,
        method: "GET"
	})
}

export function getKpointExam(data) {
	return axios({
		url: KPOINT_EXAM,
        params: data,
        method: "GET"
	})
}

export function getStartChapter(data) {
	return axios({
		url: START_EXAM_CHAPTER,
        params: data,
        method: "GET"
	})
}

export function getMockExamList(data) {
	return axios({
		url: MOCK_EXAM_LIST,
        params: data,
        method: "GET"
	})
}

export function getMockExamStart(data) {
	return axios({
		url: START_MOCK_EXAM,
        params: data,
        method: "GET"
	})
}

export function getSubmitExam(data) {
	return axios({
		url: SUBMIT_EXAM,
        params: data,
        method: "GET"
	})
}

export function getFavList(data) {
	return axios({
		url: FAV_LIST,
        params: data,
        method: "GET"
	})
}

export function getErrorList(data) {
	return axios({
		url: ERROR_LIST,
        params: data,
        method: "GET"
	})
}

export function getUserExamInfo(data) {
	return axios({
		url: USER_EXAM_INFO,
        params: data,
        method: "GET"
	})
}

export function getDeleteError(data) {
	return axios({
		url: DELETE_ERROR,
        params: data,
        method: "GET"
	})
}

export function wxWebsitePaperList(data) {
	return axios({
		url: WXWEBSITE_PAPERLIST,
        params: data,
        method: "GET"
	})
}

export function wxWebsitePaperDetail(data) {
	return axios({
		url: WXWEBSITE_PAPERDETAIL,
        params: data,
        method: "GET"
	})
}

export function wxWebsiteuserExamRecord(data) {
	return axios({
		url: WXWEBSITE_USEREXAMRECORD,
        params: data,
        method: "GET"
	})
}

export function wxWebsiteuserExamDictList(data) {
	return axios({
		url: WXWEBSITE_EXAMDICTLIST,
        params: data,
        method: "GET"
	})
}

export function userExamQueryPaperInfo(data){
	return axios({
		url:EXANQUERYPAPERINFO,
		params: data,
		method: "GET"
	})	
}



// WEBPACK FOOTER //
// ./src/api/exam.js